import React from 'react';
import PropTypes from 'prop-types';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';

function HalfStar({ size }) {
  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        width: size,
        height: size,
        lineHeight: 0,
      }}
    >
      <StarOutlined style={{ fontSize: size }} />
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '50%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <StarFilled style={{ fontSize: size }} />
      </div>
    </div>
  );
}

HalfStar.propTypes = {
  size: PropTypes.number.isRequired,
};

function StarRating({ value, size, total }) {
  const fullStars = Math.floor(value);
  const hasHalf = value % 1 >= 0.25 && value % 1 < 0.75;
  const roundedUp = value % 1 >= 0.75;
  const totalFull = fullStars + (roundedUp ? 1 : 0);

  return (
    <Row>
      <Col span={24}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <div style={{ display: 'inline-flex', gap: 2 }}>
            {[...Array(totalFull)].map((_, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <StarFilled key={`full-${i}`} style={{ fontSize: size }} />
            ))}
            {hasHalf && !roundedUp && <HalfStar size={size} />}
            {[
              ...Array(total - totalFull - (hasHalf && !roundedUp ? 1 : 0)),
            ].map((_, i) => (
              <StarOutlined
                // eslint-disable-next-line react/no-array-index-key
                key={`empty-${i}`}
                style={{ fontSize: size }}
              />
            ))}
          </div>
          <div
            style={{ fontSize: 12, fontWeight: 500, justifyContent: 'center' }}
          >
            {value}
          </div>
        </div>
      </Col>
    </Row>
  );
}

StarRating.propTypes = {
  value: PropTypes.number,
  size: PropTypes.number,
  total: PropTypes.number,
};

StarRating.defaultProps = {
  value: 0,
  size: 14,
  total: 5,
};

export default StarRating;
